// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".BarDie_button__3vXmM {\n  margin-right: -12px;\n}\n.BarDie_disabled__1I0Bd {\n  visibility: hidden;\n}\n", "",{"version":3,"sources":["webpack://src/Navigation/Bar/BarDie.module.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB","sourcesContent":[".button {\n  margin-right: -12px;\n}\n.disabled {\n  visibility: hidden;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": "BarDie_button__3vXmM",
	"disabled": "BarDie_disabled__1I0Bd"
};
export default ___CSS_LOADER_EXPORT___;
